import Footprint from './Footprint.vue'
export {
    Footprint
}

// import Vue from 'vue'
// import Footprint from './Footprint.vue'
//
// const FootprintBox = Vue.extend(Footprint);
//
// Footprint.newInstance = options => {
//
//     let instance = new FootprintBox({
//         data: options
//     }).$mount();
//
//     document.body.appendChild(instance.$el);
//
//     Vue.nextTick(() => {
//         instance.visible = true
//     });
//
// };
//
// export default {
//     show: Footprint.newInstance
// };
